<template>
<div>

<v-btn @click="openDialog" style="float:right" icon><v-icon style="font-size:22px" color="grey" small>group</v-icon></v-btn>

    
<v-dialog max-width="500" v-model="visible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" :persistent="true" :hide-overlay="false" scrollable>
<div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{settings.title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click.native="adding=!adding" icon>
                <v-icon v-if="adding">list</v-icon>
                <v-icon v-else>add</v-icon>
            </v-btn>
        </v-toolbar>
    </div>

    <!-- Body -->

    <div v-if="adding" class="dialog-body pa-3" >
        <v-text-field v-model="group.name" label="Group Name" hint="Singular (not plural) eg Client" />
        <v-switch v-model="group.role" label="Can be a role in a transaction" />
    </div>

    <div v-else class="dialog-body">
    
        <v-list two-line style="padding-top:0px">
            <template v-for="(group, i) in groups">    
                <v-list-item @click.stop="select(group)" :class="{'blue-hilight': isSelected(group)}" style="border:solid 1px transparent" >
                <v-list-item-avatar>
                    <img v-bind:src="'https://placeimg.com/40/40/people/' +i"/>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        {{group.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="group.role"><Flag value="Role"/></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-menu left offset-y  style="float:right">
                    <template v-slot:activator="{ on }">
                    <v-btn @click.stop=""  icon v-on="on" ><v-icon color="grey darken-1">keyboard_arrow_down</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click.native.stop.prevent="deleteGroup(group)">
                        <v-list-item-title>Delete group</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    </v-menu>                       
                </v-list-item-action>                    

                </v-list-item>
                <v-divider />
            </template>

            <!-- Loader -->
            <!-- <div class="grey--text pa-3" v-if="loading">
                <v-progress-circular style="display:block;margin:auto" indeterminate color="grey lighten-1"></v-progress-circular>
            </div></v-col> -->

            <!-- Option to Add -->
            <v-list-item @click.stop="adding=!adding">
                <v-list-item-avatar>
                    <v-icon x-large class="grey--text text--lighten-2">add_circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Add Group</v-list-item-title>
                    <v-list-item-subtitle>No results. Add a new one?</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>  
    </div>

    <!-- Footer -->

    <div v-if="adding" class="dialog-footer">
        <v-btn text @click.native="saveAndSelect" :disabled="!group.name">Save and Select</v-btn>                
        <v-btn text @click.native="closeDialog">Cancel</v-btn>
    </div>
    <div v-else class="dialog-footer">
        <v-btn v-if="settings.multiselect" @click.native="done" text>Done</v-btn>
        <v-btn @click.native="closeDialog" text>Cancel</v-btn>
    </div>

</div>     

</v-dialog> 

</div>        
</template>

<script>

import Utilities from '../helpers/Utilities'
import DataHelpers from '../helpers/DataHelpers'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Vue from 'vue'
import Flag from '../ui-elements/Flag'
import AlertHelpers from '../helpers/AlertHelpers'


var db = firebase.database()
var smsTemplatesRef = db.ref('empty')

export default {
data() {
    return {
        visible: false,
        adding: false,
        group: {
            name:null,
            role:false,
            stamp:null,
        },
        selectedGroups: {}
    }
},

computed: {
    
    dialogHeight() {
        if(this.$vuetify.breakpoint.smAndDown)
            return '100%'
        else
            return '500px'
    },
    
    groups() {
        return this.$store.getters.groups
    },
      
},

props: {
    settings: Object, 
    selected: Object,
},

components: {
    'Flag' : Flag
},

methods: {

    openDialog() {
        this.visible = true
        this.$store.dispatch('fetchAllGroups')
        if(this.selected)
            this.selectedGroups = Object.assign({}, this.selected)
        else    
            this.selectedGroups = {}
    },

    closeDialog    () {
        this.visible = false
        this.adding = false
        this.group.name = null
        this.group.role = null
        this.group.stamp = null
    },

    saveAndSelect() {
        this.group.stamp = DataHelpers.getStamp()
        let ref = DataHelpers.getTenantRef().child('groups')
        ref.push(this.group)        
        this.select(this.group)
    },

    done() {
        this.$emit('select', this.selectedGroups)  
        this.closeDialog()  
    },

    select(group) {
        if(this.settings.multiselect) {
            Utilities.objectToggle(this.selectedGroups, group.name)
        } else {
            this.$emit('select', group)
            this.closeDialog()
        }
    },

    deleteGroup(group) {
        this.$store.commit('deleteGroup', group)
        const ref = DataHelpers.getTransactionRef().child('groups').child(group.key)
        ref.remove()
        AlertHelpers.showAlert('Group Deleted')
        //console.log('GroupSelector > deleteGroup', group)
    },

    isSelected(item) {
        return this.selectedGroups[item.name]
    }

},
created() {
    
},
watch: {

    
}

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// GroupSelector.vue?4fcc7e1b